import { TypedDefinition } from '@rehaje/core'

import type { TransformerPlugin } from './plugin'
import type { TypedSchema } from '@rehaje/core'

export class TransformerDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'script',
      type: 'Schema.Function'
    }
  ]

  get plugin() {
    return this.getPlugin<TransformerPlugin>()
  }
}
